import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { otherUserProfile, privateRoutes } from "../../routes/routesPath";
import { format_date, isArray } from "../../utils/formatersAndParsers";
import { defaultPage, serverDataKeys } from "../../utils/constants";
import { getSlug, getUserImage, handleLoginPop, isEmpty } from "../../utils/helpers";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getOtherUserProfile } from "../../redux/otherUserProfile/thunk";
import { getOthersStoriesList } from "../../redux/stories/thunk";
import useAuth from "../../hooks/useAuth";
import MyPagination from "../../Component/common/pagination";
import StoryCard from "../../Component/storyCard/mainStoryCard";
import CardSkeleton from "../../Component/skeleton/cardSkeleton";
import UserDetailsSkeleton from "../../Component/skeleton/userDetailsSkeleton";
import NoDataFound from "../../Component/common/noDataFound";
import MyHelmet from "../../seo/helmet";

export default function OtherUserProfile({ initialData }) {
  const { isAuthenticated } = useAuth();
  const { userId } = useParams();

  const [paginationDetails, setPaginationDetails] = useState(defaultPage);
  const [showReaction, setShowReaction] = useState(false);
  const [userDetails, setUserDetails] = useState(
    initialData.dataKey === serverDataKeys.userProfile && initialData._id === userId
      ? initialData
      : {}
  );
  const [stories, setStories] = useState({});

  const handleUserProfile = async () => {
    if (isEmpty(userDetails)) {
      const response = await handleApiRequest(getOtherUserProfile, { otherUserId: userId });
      if (response.status) {
        setUserDetails(response.data);
      }
    }
  };

  const handleStoriesList = async () => {
    setStories({});
    const response = await handleApiRequest(getOthersStoriesList, {
      ...paginationDetails,
      user: userId,
    });
    if (response.status) {
      setStories(response.data);
    }
  };

  const handleLimit = (selected) => {
    setPaginationDetails((prev) => ({ ...prev, limit: selected }));
  };

  useEffect(() => {
    if (userId) {
      handleUserProfile();
    }

    return () => {
      setUserDetails({});
    };
  }, [userId]);

  useEffect(() => {
    if (userId) {
      handleStoriesList();
    }
  }, [userId, paginationDetails]);

  return (
    <>
      {userDetails?.name && (
        <MyHelmet
          title={getSlug(userDetails?.name)}
          keywords={[]}
          description={userDetails?.bio?.slice(0, 150) || ""}
          link={`${otherUserProfile}/${getSlug(userDetails.name)}/${userDetails._id}`}
        />
      )}

      <section className="">
        {userDetails.name ? (
          <div className="py-4 px-3 px-lg-5">
            <div className="d-flex align-items-center">
              <img
                src={getUserImage(userDetails)}
                alt={userDetails.name}
                onError={(e) => {
                  e.target.src = getUserImage();
                }}
                className="img-large img-fluid rounded-circle"
              />
              <div className="ms-3">
                <p className="my-0">{userDetails?.name}</p>
                <p className="muted small">User since: {format_date(userDetails?.createdAt)}</p>
                <div className="d-flex align-items-center gap-10">
                  {isAuthenticated ? (
                    <>
                      <Link
                        className="secondaryBtn p-block-1 text-white border-secondary text-decoration-none px-2"
                        to={`${privateRoutes.chatRoute}?receiver=${userDetails._id}`}>
                        Message
                      </Link>
                      {/* <Button
                        className="primaryBtn text-white py-1"
                        onClick={() => {
                          setUserAction({ action: "updatePassword" });
                        }}
                      >
                        Report User
                      </Button> */}
                    </>
                  ) : (
                    <>
                      <button
                        className="secondaryBtn border-secondary text-white"
                        onClick={() => handleLoginPop(true)}>
                        Message
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            {userDetails?.address && <p className="m-0 my-3">{userDetails?.address}</p>}
            <p className="m-0 my-3">{userDetails?.bio}</p>
          </div>
        ) : (
          <UserDetailsSkeleton />
        )}

        <div className="curvatureContainer border-0">
          <div className="bg-white">
            <div id="curved-corner-topright" className="bg-white" />
          </div>
          <div className="bg-white">
            <div id="curved-corner-topleft" className="bg-white" />
          </div>
        </div>

        <div className="pb-3 px-2 px-lg-5">
          <h4 className="mb-3">Stories</h4>

          <div className={``}>
            {stories?.totalCount > 0 ? (
              isArray(stories.records).map((story, i) => (
                <StoryCard
                  key={i}
                  story={story}
                  showReaction={showReaction}
                  setShowReaction={setShowReaction}
                />
              ))
            ) : stories?.totalCount === 0 ? (
              <NoDataFound />
            ) : (
              Array.from({ length: 3 }).map((_, i) => <CardSkeleton key={i} />)
            )}
            {stories?.totalCount > 0 && (
              <div className="d-flex justify-content-between py-3">
                <MyPagination
                  paginationDetails={paginationDetails}
                  setPaginationDetails={setPaginationDetails}
                  totalCount={stories.totalCount}
                  darkPagination={true}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
